<template>
    <section class="table-section">
        <table class="table css-table widget-table table-fixed">
            <thead>
                <tr>
                    <th class="cw-toggle"></th>
                    <th></th>
                    <th class="cw-6 text-right">Hours</th>
                    <th class="cw-6 text-right">Units</th>
                    <th class="cw-6 text-right">Amount</th>
                </tr>
            </thead>

            <tbody v-for="row in orderedRows" :key="row.key">
                <template v-if="row.kind === 'category'">
                    <tr>
                        <td class="cw-toggle position-relative">
                            <a href v-if="isExpandable(row.category)" class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': isExpanded(categoryPath(row.category))}" @click.prevent="toggle(categoryPath(row.category))">
                                <collapse-toggle-button />
                            </a>
                        </td>
                        <td>{{ row.category.name }}</td>
                        <td class="text-right">{{ displayQty(row.category.hours) }}</td>
                        <td class="text-right">{{ displayQty(row.category.units) }}</td>
                        <td class="text-right">${{ row.category.amount }}</td>
                    </tr>
                    <labor-allocation-rows v-if="isExpandable(row.category) && isExpanded(categoryPath(row.category))" :rows="row.category.rows" :depth="1" :path-prefix="categoryPath(row.category)" :is-expanded="isExpanded" :toggle="toggle" />
                </template>
                <tr v-else>
                    <td></td>
                    <td><strong>{{ row.name }}</strong></td>
                    <td></td>
                    <td></td>
                    <td class="text-right"><strong>${{ row.amount }}</strong></td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
import LaborAllocationRows from './LaborAllocationRows'

export default {
    components: {LaborAllocationRows: LaborAllocationRows},
    // is-expanded / toggle are the controlled expansion accessors provided by LaborAllocation,
    // keyed by full path so a location's Expand All can drive every nested row.
    props: ['level', 'pathPrefix', 'isExpanded', 'toggle'],
    computed: {
        categoriesByKey() {
            const byKey = {}
            // Guard against a stale/missing level shape so a transient render can't throw.
            const categories = (this.level && this.level.categories) || []
            for (const category of categories) {
                byKey[category.key] = category
            }
            return byKey
        },
        // Ordered display rows: the employee-side categories, then the Employee Net subtotal,
        // then the employer-side categories, then the Employer Cost total. Employee Net /
        // Employer Cost are non-expandable summary rows (not part of the backend categories
        // array). The backend leaves out an optional category with nothing in it.
        orderedRows() {
            const rows = []
            const pushCategory = key => {
                const category = this.categoriesByKey[key]
                if (category) {
                    rows.push({kind: 'category', key: category.key, category: category})
                }
            }
            pushCategory('earnings')
            pushCategory('deductions')
            pushCategory('wage-garnishments')
            pushCategory('employee-taxes')
            pushCategory('cash-tips')
            pushCategory('reimbursements')
            rows.push({kind: 'summary', key: 'employee-net', name: 'Employee Net', amount: this.level.employee_net})
            pushCategory('employer-taxes')
            pushCategory('employer-contributions')
            rows.push({kind: 'summary', key: 'employer-cost', name: 'Employer Cost', amount: this.level.employer_cost})
            return rows
        },
    },
    methods: {
        isExpandable(category) {
            return !!(category.rows && category.rows.length)
        },
        categoryPath(category) {
            return this.pathPrefix + '/' + category.key
        },
        // Blank out a zero quantity so the Hours / Units columns read empty rather than "0.00".
        displayQty(value) {
            return parseFloat(value) === 0 ? '' : value
        },
    },
}
</script>
